module.exports = __webpack_public_path__ + "img/instructions6.082324f3.png";